<script lang="ts" setup>
import DispatcherForm from "@/views/dispatchers/components/DispatcherForm.vue";
import { computed } from "vue";
import { useAppStore } from "@/store/app.store";
import { useRoute } from "vue-router";

const appStore = useAppStore();

const route = useRoute();

const dispatcherToEdit = computed(() => {
  return appStore.dispatchers.find((dispatcher) => {
    return dispatcher.id === Number(route.params?.id);
  });
});
</script>

<template>
  <v-container class="pt-8 pb-10 pl-6 pr-6 user-info" fluid>
    <dispatcher-form :existed-dispatcher="dispatcherToEdit" />
  </v-container>
</template>

<style lang="scss" scoped></style>
